module.exports = __webpack_public_path__ + "assets/img/question.a062c978.svg";